import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="about__content">
          <div className="about__text">
            <h2 className="about__title heading-2">The Story Behind It</h2>
            <p className="about__description">
              Furudio was built from a frustration that kept repeating.
            </p>
            <p className="about__description">
              Organizations facing collaboration challenges tend to reach for the same solution: reorganize. 
              Move people around. Create new teams. Draw a new organization chart and hope the dynamics 
              change with it.
            </p>
            <p className="about__description">
              Sometimes reorganizations are necessary. Financial pressures, mergers, genuine strategic pivots. 
              But often they are an expensive solution to a problem that lives elsewhere. Organizational 
              changes leave ripples. People scattered, priorities unclear, trust rebuilding from scratch. 
              The collaboration problem remains. The organization just has new names on the doors.
            </p>
            <p className="about__description">
              Furudio started from a different question. What if collaboration could be built into the 
              way an organization works, regardless of its structure? What if the knowledge, the data 
              and the processes existed in one shared place that stayed intact through change, rather 
              than fragmenting every time the organization chart shifted?
            </p>
            <p className="about__description">
              That question became academic research. The research became the Furudio Method. And the Furudio Method became Furudio.
            </p>
            <p className="about__description about__description--highlight">
              Organization charts define reporting lines. Furudio builds the collaboration that runs across them.
            </p>
            <p className="about__description">
              Furudio is built on a simple belief: you already have everything you need. The knowledge, 
              the people, the data. What is missing is the structure to bring it together and use it.
            </p>
            <p className="about__description">
              A workshop gets you started. After that, Furudio is yours to run. Because the people 
              who know your organization best are already inside it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
